export const handbookTitles = {
  ["mobile-apps"]: "Версии мобильного приложения",
  ["material-limits"]: "Настройка лимитов материала по конструктиву",
  ["project-limits"]: "Настройка лимитов по проекту",
  ["project-geodesists"]: "Типы проектов и группы работ для вызова геодезиста",
  ["project-usp-send"]: "Отправка оперфакта, сметы и договора в УСП",
  ["work-set-check-group-schema"]:
    "Схема приемки",
};
